import { SearchType } from '@/types/most-search-type';

export const checkLaboratorialOrVaccineSearch = (searchType: SearchType): boolean => {
  return [SearchType.LABORATORIAL_EXAM, SearchType.VACCINE].includes(searchType);
};
